"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var Appdefs = window.cccisd.appDefs;
var RegisterForm = function RegisterForm(props) {
  var showSuccessModal = function showSuccessModal() {
    var modalButton = document.getElementById('modalButton');
    if (modalButton) {
      modalButton.click();
    }
  };

  // Default is just to login after a successful register, but can be overridden with props
  // Note: If onRegisterSubmit is passed as prop, loginAfterRegister is not used
  var loginAfterRegister = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      var loginResponse, afterLoginUrl;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.login'), {
              username: values.username,
              password: values.password
            });
          case 2:
            loginResponse = _context.sent;
            if (!(loginResponse.status !== 200)) {
              _context.next = 6;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Registration was successful, but you could not login at this time.',
              type: 'danger',
              duration: 5000
            });
            return _context.abrupt("return");
          case 6:
            if (loginResponse.data.notifications.length > 0) {
              loginResponse.data.notifications.forEach(function (note) {
                return (0, _cccisdNotification["default"])(note);
              });
            }
            if (loginResponse.data.status === 'success') {
              afterLoginUrl = Fortress.settings.config.after_login_url;
              if (loginResponse.data.data.hasIncompleteSiteRegistration) {
                window.location = Boilerplate.url("/account/registrationSurvey?redirectUrl=".concat(afterLoginUrl));
              } else {
                window.location = Boilerplate.url(afterLoginUrl);
              }
            } else if (loginResponse.data.status === 'error') {
              (0, _cccisdNotification["default"])({
                message: 'Registration was successful, but you could not login at this time.',
                type: 'danger',
                duration: 5000,
                data: loginResponse.data.errors
              });
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loginAfterRegister(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var defaultOnRegisterSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
      var formValues, response, isErrorLocationInForm;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // Must copy values before manipulating or it will mutate Formik state object
            formValues = _objectSpread({}, values);
            formValues.role = props.role;
            formValues.group = props.group;
            formValues.username = formValues.username || formValues.email;
            _context2.next = 6;
            return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.pawn.store'), formValues);
          case 6:
            response = _context2.sent;
            if (!(response.status !== 200)) {
              _context2.next = 10;
              break;
            }
            (0, _cccisdNotification["default"])({
              message: 'Could not register at this time.',
              type: 'danger',
              duration: 5000,
              data: response.data && response.data
            });
            return _context2.abrupt("return");
          case 10:
            if (!(response.data.status === 'success')) {
              _context2.next = 23;
              break;
            }
            if (!props.onRegisterSuccess) {
              _context2.next = 15;
              break;
            }
            props.onRegisterSuccess(formValues, response.data.data);
            _context2.next = 21;
            break;
          case 15:
            if (!('password' in formValues && 'username' in formValues)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 18;
            return loginAfterRegister(formValues);
          case 18:
            _context2.next = 21;
            break;
          case 20:
            showSuccessModal();
          case 21:
            _context2.next = 31;
            break;
          case 23:
            if (!(response.data.status === 'error')) {
              _context2.next = 31;
              break;
            }
            // If the email field is being used as username,
            // replace 'username' error with 'email' error
            if (!values.username && response.data.errors.username) {
              response.data.errors.email = response.data.errors.username;
              delete response.data.errors.username;
            }

            // errors may come back as something like {values: "Missing required middle name."},
            // so these will be displayed in a notification instead of styling in the form
            isErrorLocationInForm = !Object.keys(response.data.errors).find(function (errLocation) {
              return !(errLocation in values);
            }); // Throwing errors object will be picked up by formik, and style the incorrect input fields
            if (!isErrorLocationInForm) {
              _context2.next = 30;
              break;
            }
            throw response.data.errors;
          case 30:
            (0, _cccisdNotification["default"])({
              message: 'Failed to register',
              duration: 10000,
              type: 'danger',
              data: response.data.errors
            });
          case 31:
            if (response.data.notifications.length > 0) {
              response.data.notifications.forEach(function (note) {
                return (0, _cccisdNotification["default"])(note);
              });
            }
          case 32:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function defaultOnRegisterSubmit(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var validate = function validate(values) {
    var errors = {};
    if (!values.email) {
      errors.email = 'E-mail is required.';
    }
    if (props.hasSeparateUsername && !values.username) {
      errors.username = 'Username is required.';
    }
    if (props.showPasswordFields) {
      if (values.password !== values.repeatPassword) {
        errors.password = 'Passwords must match.';
        errors.repeatPassword = 'Passwords must match.';
      }
      if (!values.password) {
        errors.password = 'Password is required.';
      }
      if (!values.repeatPassword) {
        errors.repeatPassword = 'Must confirm password.';
      }
      if (!values.termsandconds) {
        errors.termsandconds = 'Must accept terms and conditions to continue.';
      }
    }
    values.selfRoster = true;
    if (props.validateAdditionalFields) {
      errors = _objectSpread(_objectSpread({}, errors), props.validateAdditionalFields(values));
    }
    return errors;
  };
  var topInstructions = props.topInstructions,
    bottomInstructions = props.bottomInstructions,
    renderAdditionalFields = props.renderAdditionalFields,
    showPasswordFields = props.showPasswordFields,
    hasSeparateUsername = props.hasSeparateUsername,
    emailLabel = props.emailLabel,
    initialValues = props.initialValues,
    renderAllFields = props.renderAllFields;

  // title, buttonText could come from Fortress config (legacy) or Appdefs (current)
  var title;
  if ('title' in props) {
    title = props.title;
  } else if ((0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.title', null)) {
    title = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.title');
  } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText', null)) {
    title = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText');
  }
  var buttonText = 'Register';
  if (props.buttonText) {
    buttonText = props.buttonText;
  } else if ((0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.buttonText', null)) {
    buttonText = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.buttonText');
  } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText', null)) {
    buttonText = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.registerActionText');
  }
  var firstNameLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.firstName', 'First Name:');
  var lastNameLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.lastName', 'Last Name:');
  var emailUsernameLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.email', emailLabel || (hasSeparateUsername ? 'Email:' : 'Email / Username:'));
  var usernameLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.username', 'Username:');
  var passwordLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.password', 'Password:');
  var confirmPasswordLabel = (0, _get2["default"])(Appdefs, 'app.selfRegistration.labels.confirmPassword', 'Confirm Password:');
  var titleField = title && /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].title
  }, title);
  var topInstructionsField = topInstructions && /*#__PURE__*/_react["default"].createElement("p", {
    className: _style["default"].topInstructions
  }, topInstructions);
  var firstNameField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "first_name",
    component: _cccisdFormik.CccisdInput,
    label: firstNameLabel
  });
  var lastNameField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "last_name",
    component: _cccisdFormik.CccisdInput,
    label: lastNameLabel
  });
  var emailField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "email",
    autoComplete: "off" // stop the browser from autocompleting both the Register form and Login form
    ,
    component: _cccisdFormik.CccisdInput,
    label: emailUsernameLabel,
    type: "email"
  });
  var usernameField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "username",
    component: _cccisdFormik.CccisdInput,
    label: usernameLabel
  });
  var passwordField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "password",
    autoComplete: "new-password" // stop the browser from autocompleting both the Register form and Login form
    ,
    component: _cccisdFormik.CccisdPasswordInput,
    showPasswordToggle: true,
    label: passwordLabel
  });
  var repeatPasswordField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "repeatPassword",
    autoComplete: "new-password" // stop the browser from autocompleting both the Register form and Login form
    ,
    component: _cccisdFormik.CccisdPasswordInput,
    showPasswordToggle: true,
    label: confirmPasswordLabel
  });
  var termsAndConditionsField = /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "termsandconds",
    label: "I accept the privacy policy and terms of use.",
    component: _cccisdFormik.CccisdCheckboxInput,
    labelNotBold: true
  });
  var submitButton = function submitButton(formikProps) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      onClick: formikProps.handleSubmit,
      title: buttonText,
      className: "btn btn-primary ".concat(_style["default"].submitButton),
      isLoading: formikProps.isSubmitting
    });
  };
  var termsAndConditionsLinks = /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].termsAndCondsLinks
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.3cisd.com/privacy-policy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "http://www.3cisd.com/terms-of-use",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Terms of Use"));
  var bottomInstructionsField = /*#__PURE__*/_react["default"].createElement("p", {
    className: _style["default"].bottomInstructions
  }, bottomInstructions);
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: props.onRegisterSubmit || defaultOnRegisterSubmit,
    validate: validate,
    initialValues: _objectSpread({
      termsandconds: false
    }, initialValues),
    enableReinitialize: true
  }, function (formikProps) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, {
      className: _style["default"].form,
      autoComplete: "off"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        id: "modalButton",
        style: {
          display: 'none'
        }
      }, "click me"),
      title: "Success!",
      size: "small",
      beforeShow: function beforeShow() {
        formikProps.resetForm({});
      },
      render: function render() {
        return /*#__PURE__*/_react["default"].createElement("p", null, "Successfully registered!");
      }
    }), !renderAllFields && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, titleField, topInstructionsField, firstNameField, lastNameField, emailField, hasSeparateUsername && usernameField, renderAdditionalFields && renderAdditionalFields(formikProps), showPasswordFields && /*#__PURE__*/_react["default"].createElement("div", null, passwordField, repeatPasswordField, termsAndConditionsField), submitButton(formikProps), props.showPasswordFields && termsAndConditionsLinks, bottomInstructions && bottomInstructionsField), renderAllFields && renderAllFields({
      formikBag: formikProps,
      defaultFields: {
        title: titleField,
        topInstructions: topInstructionsField,
        firstName: firstNameField,
        lastName: lastNameField,
        email: emailField,
        username: usernameField,
        password: passwordField,
        repeatPassword: repeatPasswordField,
        termsAndConds: termsAndConditionsField,
        submitButton: submitButton,
        termsAndCondsLinks: termsAndConditionsLinks,
        bottomInstructions: bottomInstructionsField
      }
    }));
  });
};
RegisterForm.propTypes = {
  title: _propTypes["default"].string,
  topInstructions: _propTypes["default"].string,
  bottomInstructions: _propTypes["default"].string,
  buttonText: _propTypes["default"].string,
  validateAdditionalFields: _propTypes["default"].func,
  renderAdditionalFields: _propTypes["default"].func,
  renderAllFields: _propTypes["default"].func,
  onRegisterSubmit: _propTypes["default"].func,
  onRegisterSuccess: _propTypes["default"].func,
  group: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  initialValues: _propTypes["default"].object,
  role: function role(props, propName, componentName) {
    // Not required if providing your own onRegisterSubmit
    if (props.onRegisterSubmit) {
      return;
    }
    if (!(typeof props[propName] === 'string' || props[propName] instanceof String)) {
      return new Error("Invalid prop \"".concat(propName, "\" supplied to ").concat(componentName, ". PropType must be string."));
    }
  },
  showPasswordFields: _propTypes["default"].bool,
  hasSeparateUsername: _propTypes["default"].bool,
  emailLabel: _propTypes["default"].string
};
RegisterForm.defaultProps = {
  hasSeparateUsername: false,
  showPasswordFields: false
};
var _default = exports["default"] = RegisterForm;